import * as v from 'valibot';

export const deployableEnvSchema = v.fallback(
  v.pipe(
    v.picklist(
      ['prod', 'stage', 'local', 'dev', 'preview-wp-production'],
      'deployableEnv must be one of: prod, stage, local, dev, preview-wp-production',
    ),
    v.transform(val => (val === 'local' ? 'dev' : val)),
  ),
  'dev',
);
